import { RowBlackListDto } from "@/dtos";
import { BlackList } from "@/entities";
import { getPaymentMethodTypeOption } from "@/helpers/options";
import { formatToCurrency, parseToLocalDateTimeFromUtc } from "@/helpers/utilities";

export const formatRowBlackListDto = (blackLists: BlackList[]): RowBlackListDto[] => {
    return blackLists.map(x => {
        const row: RowBlackListDto = {
            ...x,
            date_label: parseToLocalDateTimeFromUtc(x.date.toString()),
            payment_method_type: getPaymentMethodTypeOption(x.payment_method.type).label,
            brand_label: x.payment_method.brand?.name ?? 'S/N',
            payment_method_identificative: x.payment_method.identificative != '' ? x.payment_method.identificative : 'S/N',
            payment_method_fare_type: x.payment_method.fare_type?.name ?? 'S/N',
            payment_method_balance: formatToCurrency(x.payment_method.balance),
            balance_returned: x.is_balance_returned ? 'Si' : 'No',
            reason: x.reason ?? 'S/N',
            payment_number: x.payment_number == '' ? 'S/N' : x.payment_number,
            passenger_label: x.payment_method.passenger ? x.payment_method.passenger.first_name + " " + x.payment_method.passenger.last_name : "S/N"
        }

        return row;
    });
}

export const formatTotalBlackListDto = (blackLists: BlackList[]) => {
    let total = 0;
    let totalReturned = 0;
    let totalPending = 0;

    for (const blackList of blackLists) {
        total += blackList.payment_method.balance;

        if (blackList.is_balance_returned) {
            totalReturned += blackList.payment_method.balance;
            continue;
        }

        totalPending += blackList.payment_method.balance;
    }

    return { total, totalReturned, totalPending };
}